module.exports = __webpack_public_path__ + "static/media/保腎2.67e4ab38.png";